<div styleClass="form-control">
    <fullDateCalendar #startDateObject
                      id="startDate"
                      [(dateStringInput)]="startDateStringInput"
                      inputStyleClass="form-control"
                      [required]="required"
                      (dateStringInputChange)="emitStartDate()">
    </fullDateCalendar>
    <span> - </span>
    <fullDateCalendar #endDateObject
                      id="endDate"
                      [(dateStringInput)]="endDateStringInput"
                      inputStyleClass="form-control"
                      [required]="required"
                      (dateStringInputChange)="emitEndDate()">
    </fullDateCalendar>
</div>
<div class="m--font-danger" *ngIf="!validInputs.isValid">{{validInputs.errorMessage}}</div>
